import Service from '@/service/index.js';
import RegExp from '@/utils/regExp.js';
export default {
  props: ['mobile', 'ticket', 'verifyCode'],
  data: () => {
    return {
      timer: null,
      smsCodeShowCount: 60
    };
  },
  methods: {
    getSendVoiceCode() {
      const payload = {mobile: this.mobile, ticket: this.ticket, verifyCode: this.verifyCode};
      if (this.smsCodeShowCount !== 60) {
        this.$alert('已接收你的请求，请注意接听', '', {
          confirmButtonText: '确定',
          callback: () => {
          }
        });
        return;
      }
      if (!this.mobile) {
        this.$errorMessage('请输入手机号');
        return;
      }
      if (!RegExp.phone.test(this.mobile)) {
        this.$errorMessage('请输入正确的手机号');
        return;
      }
      if (!this.verifyCode) {
        this.$errorMessage('请先输入图片验证码');
        return;
      }
      if (this.verifyCode && this.verifyCode.length !== 4) {
        this.$errorMessage('请输入正确的图片验证码');
        return;
      }
      Service.getSendVoiceCode(payload).then(res => {
        if (res.code === '0') {
          this.timer = setInterval(() => {
            if (this.smsCodeShowCount <= 0) {
              clearInterval(this.timer);
              this.timer = null;
              this.smsCodeShowCount = 60;
              return;
            }
            this.smsCodeShowCount--;
          }, 1000);
          this.$alert('我们将以电话的方式告知你验证码，请注意接听', '语音验证码', {
            confirmButtonText: '确定',
            callback: () => {
            }
          });
          return;
        }
        this.$errorMessage(res.data);
      }, res => {
        this.$errorMessage(res.data.reason || '发送失败');
      });
    }
  }
};
